const LINK_TYPES = Object.freeze({
  FS: 'fs',
  SS: 'ss',
  FF: 'ff',
  SF: 'sf'
});

export { LINK_TYPES };
